// Shared "New Arrival" badge — shown on a profile (public + own) while the
// player is still inside their PvP new-arrival protection window. The server
// sends `protectionEndsAt` (an ISO timestamp, or null once protection has
// lapsed), so the client never hardcodes the protection window length: the
// badge simply renders while a future end-time is present and counts down.

/** Format the time remaining until protection ends, coarsely. */
function fmtRemaining(msLeft: number): string {
  const mins = Math.floor(msLeft / 60000);
  if (mins >= 1440) {
    const days = Math.floor(mins / 1440);
    return `${days}d left`;
  }
  if (mins >= 60) {
    const hrs = Math.floor(mins / 60);
    return `${hrs}h left`;
  }
  return `${Math.max(1, mins)}m left`;
}

/**
 * Returns the HTML for a "New Arrival" pill, or an empty string when the
 * account is no longer protected (protectionEndsAt is null or in the past).
 */
export function newArrivalPill(protectionEndsAt: string | null | undefined): string {
  if (!protectionEndsAt) return '';
  const msLeft = new Date(protectionEndsAt).getTime() - Date.now();
  if (!(msLeft > 0)) return '';
  return `<span class="pill newcomer" title="New arrival — protected from PvP attacks while their account is brand new.">⚜ New Arrival · ${fmtRemaining(msLeft)}</span>`;
}
